import { Controller } from "@hotwired/stimulus"

const PAGE_URL = "https://trypush.app/"
const PAGE_TITLE = "Push — Find the right person to move forward"

export default class extends Controller {
  static values = { measurementId: String, submitted: Boolean }

  connect() {
    if (!/^G-[A-Z0-9]+$/.test(this.measurementIdValue)) return
    if (!["trypush.app", "www.trypush.app"].includes(window.location.hostname)) return
    if (window.location.pathname !== "/") return
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    this.enabled = true
    window[`ga-disable-${this.measurementIdValue}`] = false
    window.dataLayer ||= []
    window.gtag ||= function () { window.dataLayer.push(arguments) }

    // Explicit public-page metadata avoids sending query strings or private routes.
    this.pageParameters = {
      page_location: PAGE_URL,
      page_title: PAGE_TITLE,
      page_referrer: this.publicReferrer()
    }
    if (!document.querySelector("script[data-push-google-tag]")) {
      window.gtag("js", new Date())
      window.gtag("config", this.measurementIdValue, {
        ...this.pageParameters,
        send_page_view: false,
        allow_google_signals: false,
        allow_ad_personalization_signals: false
      })
      const script = document.createElement("script")
      script.async = true
      script.dataset.pushGoogleTag = "true"
      script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementIdValue}`
      document.head.appendChild(script)
    }

    this.send("page_view")
    if (this.submittedValue) {
      this.send("generate_lead")
      // A Turbo restoration of this success page must not count another submission.
      this.submittedValue = false
    }
    this.stopTracking = () => { window[`ga-disable-${this.measurementIdValue}`] = true }
    document.addEventListener("turbo:before-visit", this.stopTracking)
  }

  disconnect() {
    if (!this.enabled) return
    this.stopTracking()
    this.enabled = false
    document.removeEventListener("turbo:before-visit", this.stopTracking)
  }

  findPerson() { this.send("find_person_click") }
  learnMore() { this.send("learn_more_click") }

  send(name) {
    if (!this.enabled) return
    window.gtag("event", name, { ...this.pageParameters, send_to: this.measurementIdValue })
  }

  publicReferrer() {
    try {
      const url = new URL(document.referrer)
      return ["http:", "https:"].includes(url.protocol) ? `${url.origin}/` : ""
    } catch { return "" }
  }
}
